import { Observable } from "rxjs";

import { GetAdsResponse } from "@coin-depo-types";

export interface AdvertisementFacade {
  cachedAddLtv$: Observable<number>;
  getAds(): Observable<GetAdsResponse>;
}